// Patterns are especially double-escaped
// so that when they used as the `pattern` prop on an input,
// React won't sanitise the escapes by mistake.
export const ALPHA_ONLY_PATTERN = '^[a-zA-Z\ \-\']+$'
/**
 * Source: https://github.com/lux-group/svc-auth/blob/44e935f26b8de4d01b31d6b11d9f46fc8be0e958/src/models/user/schemas.js#L17-L19
 */
export const EMAIL_PATTERN = "^[a-zA-Z0-9!#$%&'*+\\/=?^_`\\{\\|\\}~\\-]+(?:\\.[A-Za-z0-9!#$%&'*+\\/=?^_`\\{\\|\\}~\\-]+)*@(?:[A-Za-z0-9\\-]+\\.)+[A-Za-z0-9]+$"
